import { render } from "./TicketActionDialogFooter.vue?vue&type=template&id=4b15d455"
import script from "./TicketActionDialogFooter.vue?vue&type=script&lang=js"
export * from "./TicketActionDialogFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__